import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import {
  ExpandMore,
  ChevronRight,
  Folder,
  InsertDriveFile,
} from '@mui/icons-material';

export const formatFileSize = (bytes) => {
  if (!bytes) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  return new Date(dateString).toLocaleString();
};

export default function FileTreeItem({ name, data, path = [] }) {
  const [open, setOpen] = useState(false);
  const isDirectory = data && data.type === 'directory';

  const handleClick = () => {
    if (isDirectory) {
      setOpen(!open);
    }
  };

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          py: 0.5,
          cursor: isDirectory ? 'pointer' : 'default',
          '&:hover': {
            backgroundColor: 'action.hover'
          }
        }}
        onClick={handleClick}
      >
        {isDirectory ? (
          open ? <ExpandMore fontSize="small" /> : <ChevronRight fontSize="small" />
        ) : (
          <Box sx={{ width: 20 }} />
        )}
        {isDirectory ? (
          <Folder color="primary" fontSize="small" />
        ) : (
          <InsertDriveFile color="action" fontSize="small" />
        )}
        <Typography variant="body2">{name}</Typography>
        <Typography variant="caption" color="text.secondary">
          {isDirectory
            ? `(${data.fileCount || 0} files, ${formatFileSize(data.totalSize || 0)})`
            : `(${formatFileSize(data.size || 0)})`
          }
        </Typography>
      </Box>
      {isDirectory && open && data.files && (
        <Box sx={{ pl: 3 }}>
          {Object.entries(data.files).map(([childName, childData]) => (
            <FileTreeItem
              key={[...path, name, childName].join('/')}
              name={childName}
              data={childData}
              path={[...path, name]}
            />
          ))}
        </Box>
      )}
    </Box>
  );
}
